/**
 * "Stop watching" — the ONE exit path out of a watch, shared with the spectator
 * result card (`overlay/ResultOverlay`), mirroring the old screen's single
 * `setGameId('stop_watching')` route (index.js L1394-1397 / L1490-1500 / the
 * `[gameId]` effect L4323-4331).
 *
 * Three steps, in this order: restore the RAIL tab the watch was started from
 * (`rail/watchSourceTab`, falling back to 'pairings' as the old screen's own
 * 'games' fallback does), drop the browsed ply, and reset the watch slice
 * without waiting for the server's echo — which is what takes the rail back to
 * 'tournament'.
 */
import {useCallback} from 'react';

import {useLiveGame} from '@/Store/liveGameStore';

import {takeWatchSourceTab} from '../../../watchSourceTab';
import {useV2Ui} from '../../../../theme/useV2Ui';

export type StopWatchingTileModel = {
  onPress: () => void;
};

export function useStopWatchingTileModel(): StopWatchingTileModel {
  const stopWatchingGame = useLiveGame(s => s.actions.stopWatchingGame);

  const onPress = useCallback(() => {
    const ui = useV2Ui.getState();
    ui.setRailTab(takeWatchSourceTab());
    ui.setViewPly(null);
    ui.setWatchResultReady(false);
    ui.setResultDismissed(false);
    stopWatchingGame();
  }, [stopWatchingGame]);

  return {onPress};
}
